import React, { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import Button from '@material-ui/core/Button'
import { CustomSnackBarContent } from '~shared/components/atoms/CustomSnackBar'
import shouldSuppressSnackbar from '~shared/utils/shouldSuppressSnackbar'

export const useCustomSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const enqueueCustomSnackbar = useCallback(
    alert => {
      if (typeof window !== 'undefined' && shouldSuppressSnackbar(window.location.pathname)) {
        return
      }
      const {
        message,
        stack,
        variant,
        duration = 6000,
        dontHide = false,
        preventDuplicate = false,
        customAction,
      } = alert

      if (message === undefined || message === null || message === '') {
        return
      }

      enqueueSnackbar('', {
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        autoHideDuration: duration,
        persist: dontHide,
        preventDuplicate,
        children: key => (
          <CustomSnackBarContent
            onClose={() => closeSnackbar(key)}
            message={message + (stack ? ': ' + stack : '')}
            variant={variant}
            customActions={
              customAction && [
                <Button
                  color="secondary"
                  style={{ height: '100%', width: '100%', position: 'absolute', left: 0, top: 0 }}
                  onClick={() => {
                    window.navigateTo(customAction)
                  }}
                />,
              ]
            }
          />
        ),
      })
    },
    [closeSnackbar, enqueueSnackbar],
  )

  return {
    enqueueSnackbar: enqueueCustomSnackbar,
    closeSnackbar,
  }
}
